// extracted by mini-css-extract-plugin
export default {"userContainer":"ChangeUserRolesModal__userContainer___pVgrL","checkbox":"ChangeUserRolesModal__checkbox___D3IKW"};